import { ContainerModule } from 'inversify';
import { NotificationService } from '@xlearn/async-toolbox'
import { NotificationServiceSymbol } from './symbol'
import { NotificationStoreModule, NotificationStoreModuleSymbol } from '../store'

export const notificationServiceModule = new ContainerModule((bind) => {
  bind(NotificationServiceSymbol).toDynamicValue(context => {
    const store = context.container.get<NotificationStoreModule>(NotificationStoreModuleSymbol)
    return new NotificationService(store)
  }).inSingletonScope()
});
